import styled, { css } from 'styled-components';

const ContainerStyled = styled.div<{ color?: string }>`
  width: 100%;
  height: 8px;

  border-radius: 3px;

  display: flex;
  gap: 1px;

  overflow: hidden;

  ${({ color }) => {
    if (color) {
      return css`
        background-color: ${color};
      `;
    }

    return css`
      background-color: var(
        --ds-background-accent-gray-subtlest,
        var(--ds-fb-background-accent-gray-subtlest)
      );
    `;
  }}
`;

const ValueStyled = styled.div<{ value: number; color: string }>`
  ${({ value, color }) =>
    css`
      width: ${value}%;
      background-color: ${color};
    `}
`;

export const DataBar = {
  Container: ContainerStyled,
  Value: ValueStyled,
};
